import React from 'react';
import PropTypes from 'prop-types';
import SchemaField from './Fields/SchemaField';

export default class FormResponse extends React.PureComponent {

  static propTypes = {
    formData: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object.isRequired
  }

  render() {
    const { onChange, formData, schema, uiSchema } = this.props;
    const hasQuestions =
      schema && schema.properties && Object.keys(schema.properties).length > 0;
    return (
      <div>
        {!hasQuestions &&
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <h3>This form has no questions</h3>
          </div>}
        {hasQuestions &&
          <SchemaField
            schema={schema}
            formData={formData}
            onChange={onChange}
            uiSchema={uiSchema}
          />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Renderer.js